import { Sentry } from '@src/core/sentry';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

import Main from './main';
import { store } from '@src/store';
import '@src/styles/global.css';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { ThemeProvider } from '@mui/material';
import { theme } from './styles/mui';
import { Confirm } from './core/controllers';

// React dev build emits performance.mark/measure for every render via the
// profiler hook. Under heavy churn (telemetry-driven re-renders for many
// drones) these PerformanceMeasure objects accumulate in window.performance
// and never get cleared, ballooning the heap. In dev, drop them periodically.
if (process.env.NODE_ENV !== 'production' && typeof window !== 'undefined' && window.performance) {
  setInterval(() => {
    try {
      window.performance.clearMarks();
      window.performance.clearMeasures();
      window.performance.clearResourceTimings();
    } catch {
      // some browsers throw on partial support — best effort
    }
  }, 5000);
}

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);
root.render(
  <Sentry.ErrorBoundary
    fallback={<div style={{ padding: 24, fontFamily: 'sans-serif' }}>Something went wrong. Please reload the page.</div>}
    showDialog={false}
  >
    <ThemeProvider theme={theme}>
      <BrowserRouter>	
        <Provider store={store}>
          <Main />
          <ToastContainer hideProgressBar={true} limit={5} autoClose={4000} newestOnTop closeOnClick pauseOnFocusLoss={false} />  
          <Confirm />
        </Provider>
      </BrowserRouter>
    </ThemeProvider>
  </Sentry.ErrorBoundary>
);
